import * as m from 'mithril';
import './index.scss';

import ContactView from './views/contact/contact.component';
import FooterView from './views/common/footer.component';
import HeaderView from './views/common/header.component';
import HomeView from './views/home/home.component';
import MusicView from './views/music/music.component';
import PromoLandingView from './views/promo/landing.component';
import ShowsView from './views/shows/shows.component';
import StoreView from './views/store/store.component';

const footer = document.querySelector('footer');
const header = document.querySelector('header');
const main = document.querySelector('main');

m.mount(footer, FooterView);
m.mount(header, HeaderView);

m.route.prefix = '';
m.route(main, '/home', {
    '/contact': ContactView,
    '/home': HomeView,
    '/music': MusicView,
    '/shows': ShowsView,
    '/store': StoreView,
    '/p': PromoLandingView,
});

// let path = m.route.get();
// console.log(`###> ${path}`);